import { render, staticRenderFns } from "./economicEnvironment.vue?vue&type=template&id=948de00e&scoped=true"
import script from "./economicEnvironment.vue?vue&type=script&lang=js"
export * from "./economicEnvironment.vue?vue&type=script&lang=js"
import style0 from "./economicEnvironment.vue?vue&type=style&index=0&id=948de00e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948de00e",
  null
  
)

export default component.exports